import { HttpAction, HttpService } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { unitTemplateCategories } from "./unitTemplate";

export const calculatorTemplateSerializer = Serializers.object({
  id: Serializers.string,
  unit: Serializers.string,
  category: Serializers.stringOneOf(...unitTemplateCategories),
  label: Serializers.string,
  complexity: Serializers.integer,
  components: Serializers.record(Serializers.integer),
});
export type CalculatorTemplate = SerializerValue<typeof calculatorTemplateSerializer>;

export const calculatorContextSerializer = Serializers.object({
  templates: calculatorTemplateSerializer.array(),
  inputUnits: Serializers.record(Serializers.integer),
  topCosts: Serializers.record(Serializers.integer),
  fillerCosts: Serializers.record(Serializers.integer),
});
export type CalculatorContext = SerializerValue<typeof calculatorContextSerializer>;

export type MaterializedTopUnit = {
  topUnit: string;
  inputs: Partial<Record<string, number>>;
  filler: Partial<Record<string, number>>;
  templateUses: Partial<Record<string, number>>;
};

export const materializedTopUnitSerializer = Serializers.object<MaterializedTopUnit>({
  topUnit: Serializers.string,
  inputs: Serializers.record(Serializers.integer),
  filler: Serializers.record(Serializers.integer),
  templateUses: Serializers.record(Serializers.integer),
});

export type CalculatorOutput = {
  unallocated: Partial<Record<string, number>>;
  topUnits: MaterializedTopUnit[];
};

export const calculatorOutputSerializer = Serializers.object<CalculatorOutput>({
  unallocated: Serializers.record(Serializers.integer),
  topUnits: materializedTopUnitSerializer.array(),
});

export const solutionSerializer = Serializers.object({
  totalCost: Serializers.decimal,
  topCost: Serializers.decimal,
  fillerCost: Serializers.decimal,
  unallocated: Serializers.record(Serializers.integer),
  topUnits: Serializers.object({
    unit: Serializers.string,
    quantity: Serializers.integer,
    cost: Serializers.decimal,
    topCost: Serializers.decimal,
    fillerCost: Serializers.decimal,
    inputs: Serializers.record(Serializers.integer),
    filler: Serializers.record(Serializers.integer),
    templateUses: Serializers.record(Serializers.integer),
    fillerCosts: Serializers.record(Serializers.decimal),
  }).array(),
});

export type ShippingSolution = SerializerValue<typeof solutionSerializer>;

export const calculateInputSerializer = Serializers.object({
  items: Serializers.object({
    itemId: Serializers.string,
    quantity: Serializers.integer,
  }).array(),
  shippingRates: Serializers.record(Serializers.decimal),
  fillerCosts: Serializers.record(Serializers.decimal),
});
export type CalculateInput = SerializerValue<typeof calculateInputSerializer>;

export const calculateActions = HttpService({
  calculate: HttpAction({
    method: "post",
    path: "/calculate",
    bodySerializer: calculateInputSerializer,
    errorSerializer: Serializers.stringOneOf("NoSolution"),
    valueSerializer: solutionSerializer,
  }),
});
